<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <page-header
          title="Login to Your Account"
          :center_title="false"
          :return_button="false"
          :action_button="false"
          action_button_text=""
          action_button_link=""
        ></page-header>
        <div class="row mt-4">
          <div class="col-md-12">
            <div v-if="success" class="alert alert-success" role="alert">
              {{ success }}
            </div>
            <div
              v-if="errors.length > 0"
              class="alert alert-danger"
              role="alert"
            >
              <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>
            <div class="form-group">
              <label for="email" class="form-label">Enter your Email.</label>
              <input
                type="email"
                class="form-control"
                id="email"
                placeholder="name@example.com"
                v-model="form.email"
                :disabled="loading.form"
              />
            </div>
            <div class="form-group">
              <label for="password" class="form-label"
                >Enter your Password.</label
              >
              <input
                type="password"
                class="form-control"
                id="password"
                placeholder="***********"
                v-model="form.password"
                :disabled="loading.form"
              />
            </div>
            <button
              @click.prevent="onSubmit"
              type="button"
              class="btn btn-dark mt-2 w-100 box-shadow-light"
              :disabled="loading.form"
            >
              {{ loading.form ? "Loading, please wait..." : "Login" }}
            </button>
            <div class="mt-3 text-center" style="font-size: 0.9rem">
              Not yet registered? <br />
              <a href="/register"
                ><span style="color: black; font-weight: bold"
                  >Sign Up here.</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import PageHeader from "@/components/layout/navigation/PageHeader.vue";
import { formatErrors } from "@/utils/helpers";

export default {
  name: "LoginView",
  components: {
    PageHeader,
  },
  data() {
    return {
      loading: {
        form: false,
      },
      form: {
        email: "",
        password: "",
      },
      success: "",
      errors: [],
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;

      let action = "";
      let payload = {};
      action = "user/login";
      payload = {
        email: this.form.email,
        password: this.form.password,
      };

      // Process submission
      // eslint-disable-next-line no-unused-vars
      this.$store
        .dispatch(action, payload)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          let route = "";

          this.success = "Login successful.";

          this.$emit("refreshWishlistCount");
          this.$emit("refreshCartCount");

          // redirect to home or redirect route if set.
          if (this.$route.query.redirect) {
            route = this.$route.query.redirect;
          } else {
            route = "/";
          }

          this.$router.push(route);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status === 422 || error.response.status === 401) {
            let scope = this;
            scope.errors = formatErrors(error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>